import { LazyImport, LazyModule } from 'owa-bundling';
import { BaseLinkPreviewObject } from './utils/BaseLinkPreviewObject';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "LinkPreview" */ './lazyIndex')
);

export const lazyCreateLinkPreview = new LazyImport(lazyModule, m => m.createLinkPreview);
export const lazyRehydrateLinkPreview = new LazyImport(lazyModule, m => m.rehydrateLinkPreview);

export { BaseLinkPreviewObject };
